module.exports = __webpack_public_path__ + "img/qualifications4.00b042d0.png";